import { API_BASE_URL } from './config';

export type CatalogStats = {
  estadosActivos: number;
  productosEnVenta: number;
  ciudadesActivas: number;
  sucursalesActivas: number;
  clientesActivos: number;
  estados: string[];
  productos: string[];
  ciudades: string[];
  sucursales: string[];
  clientes: string[];
};

export type StatListKey = 'estados' | 'productos' | 'ciudades' | 'sucursales' | 'clientes';

export async function fetchCatalogStats(): Promise<CatalogStats> {
  const res = await fetch(`${API_BASE_URL}/api/stats`);
  if (!res.ok) {
    throw new Error(`API ${res.status}: /api/stats`);
  }
  const data = await res.json() as Partial<CatalogStats>;
  return {
    estadosActivos: data.estadosActivos ?? 0,
    productosEnVenta: data.productosEnVenta ?? 0,
    ciudadesActivas: data.ciudadesActivas ?? 0,
    sucursalesActivas: data.sucursalesActivas ?? 0,
    clientesActivos: data.clientesActivos ?? 0,
    estados: data.estados ?? [],
    productos: data.productos ?? [],
    ciudades: data.ciudades ?? [],
    sucursales: data.sucursales ?? [],
    clientes: data.clientes ?? [],
  };
}
